export default {
  GET_GENDERS_QUERY_SERVICE: Symbol.for('GET_GENDERS_QUERY_SERVICE'),
  GENDER_REPOSITORY: Symbol.for('GENDER_REPOSITORY'),
  ONBOARDING_CATALOG_GENDER_STATE_MANAGER: Symbol.for('ONBOARDING_CATALOG_GENDER_STATE_MANAGER'),
};
